/**
 * @desc 查询熟料生产周计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekClinkerResponse>> {
  return defHttp.post({
    url: '/wap/plan/week/queryPlanClinker',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekClinkerResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/week/queryPlanClinker',
    data,
  });
}
